<template>
  <v-tabs align-with-title>
    <menu-item
      v-for="route of userRoutes"
      :key="route.path"
      :route="route.path"
      :label="route.meta.label"
      :icon="route.meta.icon"
    ></menu-item>
  </v-tabs>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import MenuItem from './MenuItem.vue'
import { routes } from '@/router/routes'
import { isAllowed, DIVISIONS } from '@/utils/authentication'
const configModule = createNamespacedHelpers('config')
const authModule = createNamespacedHelpers('authentication')

export default {
  name: 'MainMenu',
  components: { MenuItem },
  computed: {
    ...configModule.mapState(['divisions', 'currentDivision']),
    ...authModule.mapGetters(['user']),
    userRoutes() {
      return routes.filter(r => {
        if (r.meta) {
          const { role, divisions } = r.meta.authorization
          if (isAllowed(this.user, role, divisions)) {
            if (
              divisions.includes(DIVISIONS.ALL) ||
              divisions.includes(this.currentDivision)
            ) {
              return true
            }
          }
        }
        return false
      })
    }
  }
}
</script>

<style></style>
